// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "me.komet.app",
    name: "Komet",
    homepage: "https://komet.me",
    image_id: "a2e9aaed-20f6-4da9-3ca3-448a1fc00b00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/in/app/komet/id6448238558",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/komet-wallet/anmkkggohcdelhaholjialcfgdbcegbo",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "me.komet.app",
    mobile: {
        native: "komet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map